export const SECTION_NAME = 'product-new';

export const ACTIVE_CURRENCY = window?.Shopify?.currency?.active ?? 'USD';
export const SHOW_CURRENCY_NAME = false;
export const REMOVE_TRAILING_ZEROS = true;

export const selectors = {
    productForm: '[data-product-form]',
    productFormMobile: '[data-product-form-mobile]',
    optionAccordions: '[data-product-option] summary',
    option2ValueSelectors: '[data-option2-value]',
    option3ValueSelectors: '[data-option3-value]',
    formControls: '[data-form-controls]',
    submitButton: '[data-product-submit-button]',
    buyNowButton: '[data-product-buy-now]',
    buyNowButtonLabel: '[data-product-buy-now-text]',
    submitButtonLabel: '[data-product-submit-text]',
    submitButtonSuccessLabel: '[data-product-submit-success-text]',
    productSelect: '[data-product-select]',
    selectedOptionValues: '[data-selected-option-value]',
    selectedOptionValuesLength: '[data-selected-option-value-length]',
    selectedColorSwatches: '[data-selected-color-swatch]',
    numberOfAvailableOptions: '[data-options-available-text]',
    imagesContainer: '[data-product-images]',
    mainSlider: '[data-product-images-slider]',
    mainSlide: '[data-main-slide]',
    mainSliderWrapper: '[data-product-images-wrapper-desktop]',
    thumbsSlider: '[data-product-thumbnails-carousel]',
    stockState: '[data-stock-state]',
    productJson: '[data-product-json]',
    settingsJson: '[data-settings-json]',
    lashSettingsJson: '[data-lash-settings-json]',
    allImages: '[data-json-product-images]',
    selectedSellingPlan: '[data-selected-selling-plan]',
    sellingPlanInput: '[data-selling-plans-selector]',
    titleOption: '[data-quickview-title-option]',
    accordionsContainer: '[data-accordions-container]',
    independentAccordion: '[data-accordion-independent]',
    quantity: `[data-product-quantity]`,
    quantityButton: `[data-product-quantity-button]`,
    quantityInput: `[data-product-quantity-input]`,
    optionsSlider: '[data-product-options-slider]',
    optionItemSlider: '[data-product-option-item-slider]',
    pricesWrapper: '[data-product-subscription-selector-wrapper]',
    monthlyBoxModalTrigger: '[data-monthly-box-modal]',
    optionImage: '[data-option-image]',
    productMobileProgressTitle: '[data-product-mobile-progress-title]',
    multipleOptionSelector: '[data-multiple-option-selector]',
    multipleOptionSelectorButtonDelete: '[data-multiple-option-selector-button-delete]',
    multipleOptionSelectorButtonDecrease: '[data-multiple-option-selector-button-decrease]',
    multipleOptionSelectorText: '[data-multiple-option-selector-text]',
    multipleOptionSelectorButtonIncrease: '[data-multiple-option-selector-button-increase]',
    multipleOptionSelectorLengthCount: '[data-multiple-option-selector-length-count]',
    multipleOptionNextStep: '[data-multiple-option-next-step]',
    boxFeaturesMb: '[data-box-features-mb]',
    boxFeaturesOtp: '[data-box-features-otp]',
    boxFeaturesMbDiscountTiers: '[data-box-features-mb-discount-tiers]',
    boxFeaturesMbDiscountTierLockedIcon: '[data-box-features-mb-discount-tier-locked-icon]',
    boxFeaturesMbDiscountTierTitle: '[data-box-features-mb-discount-tier-title]',
    boxFeaturesMbDiscountTiersProgressBarFill: '[data-box-features-mb-discount-tiers-progress-bar-fill]',
    boxFeaturesMbTitle: '[data-box-features-mb-title]',
    productSubmitButtonMobile: '[data-product-submit-button-mobile]',
    boxFeaturesMbCount: '[data-box-features-mb-count]',
    infoBarSubtitle: '[data-subscription-info-bar-subtitle]',
    infoBarIconDefault: '[data-info-bar-icon-default]',
    infoBarIconUnlocked: '[data-info-bar-icon-unlocked]',
    productCompareAddAndOpen: '[data-product-compare-add-and-open]',
    pmrw: '[data-pmrw]',
    pmrwSticky: '[data-pmrw-sticky]',
    quantityLimits: '[data-quantity-limits]',
    couponNote: '[data-coupon-note]',
};

export const classes = {
    disabled: 'disabled',
    hide: 'hide',
    loading: 'loading',
    swiperSlide: 'swiper-slide',
};

export const QUERY_CART = `query Cart($id: ID!) {
  cart(id: $id) {
    id
    lines(first: 250) {
      nodes {
        id
        quantity
        attributes {
          key
          value
        }
        sellingPlanAllocation {
          sellingPlan {
            id
            name
          }
        }
        merchandise {
          ... on ProductVariant {
            id
            product {
              id
              tags
            }
          }
        }
      }
    }
  }
}`;
